import React, { PropTypes, Component } from 'react';
import ParticipateButtons from 'project/containers/participate_buttons';
import InfoFormName from 'project/components/participate_form/info_form_name';
import { isProjectTagline } from 'project/utils';
import { removeExtraSpaces } from 'common/utils';

/**
 * Participate info step for name entries.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class InfoStepName extends Component {
  constructor(props) {
    super(props)
    this.state = { name: '', description: '', domain_available: false }
    this.updateEntry = this.updateEntry.bind(this)
    this.updateName = this.updateName.bind(this);
    this.updateDescription = this.updateDescription.bind(this);
    this.updateDomainAvailable = this.updateDomainAvailable.bind(this);
  }

  updateEntry(e, field) {
    const entry = { ...this.state, [field]: e.target.value}
    this.setState(entry)
  }

  updateName(e) {
    this.updateEntry(e, 'name')
  }

  updateDescription(e) {
    this.updateEntry(e, 'description')
  }

  updateDomainAvailable(e) {
    this.updateEntry(e, 'domain_available')
  }

  render() {
    const entry = this.state;
    const { onCloseForm, onSubmitParticipateForm, submissionError, submittingForm,
      project } = this.props;
    const isTagline = isProjectTagline(project);

    return (
      <div className="participate-step name-step">
        <div className="modal-header">
          <h5>Submit a { isTagline? 'Tagline' : 'Name' }</h5>
        </div>
        <div className="modal-content">
          <div className="participate-fields naming">
            <InfoFormName entry={entry} updateName={this.updateName}
              updateDescription={this.updateDescription} isTagline={isTagline}
              updateDomainAvailable={this.updateDomainAvailable} />
          </div>
          <div className="modal-actions right">
            <ParticipateButtons
              action={() => { onSubmitParticipateForm(entry); }}
              nextActive={entry.name !== '' && removeExtraSpaces(entry.description).length >= 100}
              onToggleForm={onCloseForm}
              actionError={submissionError}
              actionProcessing={submittingForm}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./project/components/participate_form/info_step_name.jsx